import React from 'react';
import './Plans.css';
import { Row, Col, Button, AutoComplete, Input, Form, Skeleton } from "antd";

const Plans=()=>{
return(
    <div >
        
    <div className='plan-select'>
        
    <Col xs={22} sm={22} md={22} lg={12} xl={12} className="plan-divselected">
<Row className='plan-rowselected'>
    <div className='plan-head1'>Select plan</div>
    <div className='plan-head1'>Change plan</div>
</Row>
<div className='plan-ent'>Enterprise</div>
<div className='plan-rate'>From $100</div>

</Col>

    </div>
    
    <div style={{display: "flex", justifyContent: "center"}}>
        <Col xs={22} sm={22} md={22} lg={12} xl={12} >
        <div className='plan-build'>Build your plan</div>
        <div className='plan-entplan'>Subscribe enterprise plan</div>
        <div className='plan-desc'>Auto-renews monthly, cancel anytime.</div>
        <div className='plan-subsdiv'>
            <div>Monthly subscriptions</div>
            <div>$100/Month </div>
        </div>

        <div className='plan-entplan'>Pay in advance</div>
        <div className='plan-desc'>One time payment, Does not auto renew</div>

        <div>

        <div  className='plan-subsdiv'>
            <div className='plan-save'>Save $200</div>
            <div className='plan-year'>1 year</div>
            <div>one time payment of $1000</div>
        </div>

        <div  className='plan-subsdiv'>
            <div className='plan-save'>Save $200</div>
            <div className='plan-year'>1 year</div>
            <div>one time payment of $1000</div>
        </div>

        <div  className='plan-subsdiv'>
            <div className='plan-save'>Save $200</div>
            <div className='plan-year'>1 year</div>
            <div>one time payment of $1000</div>
        </div>
        </div>
</Col>
        </div>
        
    </div>

)
}

export default Plans;